module.exports = __webpack_public_path__ + "9c33d834a530c8719d155a8867777dcd.png";